<iframe
  id="contact-section"
  title="Formulaire de contact Freshsales"
  [attr.src]="URL_CONTACT_FORM_FRESHSALES | safe"
  frameborder="0"
  scrolling="yes"
  width="100%"
  [style.height.px]="iframeHeight"
  marginheight="0"
  marginwidth="0"
  name="landing-page-embed-frame"
  wmode="transparent"
  style="height: 100vh"
></iframe>
